const $$splitComponentImporter = () => import('/src/src/routes/_session.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";
export const Route = createFileRoute("/_session")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    referrer: z.string().optional(),
    // SSO hands RelayState back as either a relative path to restore, or a JSON payload of
    // metadata, which the router parses into an object.
    RelayState: z.union([z.string(), z.record(z.string(), z.unknown())]).optional()
  }))
});